import Image from 'app/Components/Shared/Image/image';
import React, { useState, useEffect } from 'react';
import light from '../../icons/light-updates.svg';

export default function Updates(props) {
  const [isExpanded, setIsExpanded] = useState(false);
  const displayedMessages = isExpanded ? props.messages : props.messages?.slice(0, Math.min(props.initialOpenCount, props.messages.length));
  const isDisplayButton = props.messages?.length > props.initialOpenCount;

  const toggleList = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <>
      {
        displayedMessages?.length > 0 &&
        <div className='wrapper-updates'>
          <div className='container-updates'>
            {displayedMessages?.map((msg, index) => (
              <div className='message' key={index}>
                <Image src={light} alt='icon' />
                <div>{msg.message}</div>
              </div>
            ))}
          </div>
          {isDisplayButton &&
          <div className='btn-wrapper'>
            <button onClick={toggleList}>
              {isExpanded ? 'סגירה' : 'עוד עדכונים'} <span className={`arrow ${ isExpanded ? '' : 'open-arrow'}`}/>
            </button>
          </div>}
        </div> 
      }   
    </>
  );
}
